export default __webpack_public_path__ + "static/media/names.bbe97e81.svg";